export default "__VITE_ASSET__Bn0$gQVI__"